import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { finopsApiRef, FinopsApiClient } from './api';
import { rootRouteRef } from './routes';

export const finopsPlugin = createPlugin({
  id: 'finops',
  apis: [
    createApiFactory({
      api: finopsApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new FinopsApiClient(discoveryApi, fetchApi),
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});

export const FinopsPage = finopsPlugin.provide(
  createRoutableExtension({
    name: 'FinopsPage',
    component: () =>
      import('./components/FinopsPage/FinopsPage').then(m => m.FinopsPage),
    mountPoint: rootRouteRef,
  }),
);
